import { render, staticRenderFns } from "./GatewayStatus.vue?vue&type=template&id=7252c13d&scoped=true&"
import script from "./GatewayStatus.vue?vue&type=script&lang=js&"
export * from "./GatewayStatus.vue?vue&type=script&lang=js&"
import style0 from "./GatewayStatus.vue?vue&type=style&index=0&id=7252c13d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252c13d",
  null
  
)

export default component.exports